import { keys, pickBy, omit } from 'lodash'
import errorActions from '../errors/errors-actions'
import fieldActions from '../fields/fields-actions'
import Rules from './rules'


// Validate only the specified fields 
const validateOnly = (fields, rules) => {
	return {
		type: 'VALIDATE_ONLY',
		fields,
		rules
	}
}

// Validate against the current formConfig
const validate = (successCallback) => (dispatch, getState) =>{
    console.log("Validate")

    var state = getState()
    const fields = state.fields
    const formData = state.form.getData()
    const rules = formData.rules
    const predicates = formData.predicates
    
    // We only want to validate the relevant fields, not the fields with false predicates
    const falsePredicates = keys( pickBy(predicates, value => value == false) )
    const rulesWithFieldsSatifyingPredicate = omit(rules, falsePredicates)
    const fieldsSatisfyingPredicate = omit(fields, falsePredicates)

    // Perform the validation checks
    const errors = Rules.validate(fields, rulesWithFieldsSatifyingPredicate)
    console.log("Errors")
    console.log(errors)
    dispatch(errorActions.setErrors(errors))
    
    dispatch( (dispatch, getState) =>{
        state = getState()
        if(keys(state.errors).length == 0){
            console.log("Validate success")
            dispatch( fieldActions.clearFields( falsePredicates ))
            successCallback();
        }else{
            console.log("Validate errors")
            console.log(state.errors)
            dispatch( errorActions.scrollToErrors() )
        }
    })
}


export default {
    validateOnly,
    validate
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/validation/validation-actions.ts